import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ breakpoints, spacing, palette }) => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 0px',
  },
  container: {
    display: 'flex',
    width: '100%',
    height: '100%',
    padding: '32px',
    flexDirection: 'column',
  },
  titleWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    padding: '30px 50px',
  },
  title: {
    fontFamily: 'DM Sans',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '24px',
    lineHeight: '112.5%',
    color: '#141414',
  },
  fieldsContainerFlex: {
    display: 'flex',
    gap: '30px',
    width: '100%',

    [breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  fieldsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: '30px',
    width: '100%',
    justifyContent: 'space-between',
    '& > *': {
      flex: '1 1 auto',
      minWidth: '0',
    },

    [breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  rulesField: {
    fontSize: Theme.Typography.FontSize.Tiny,
    fontFamily: [Theme.Typography.FontFamily.Roboto, 'sans-serif'],
    fontWeight: Theme.Typography.FontWeight.Small,
  },
  radioLabel: {
    lineHeight: 0,
    color: palette.gray[64],
    fontSize: spacing(14),
    marginBottom: spacing(4),
    '& .MuiFormLabel-asterisk': {
      display: 'none',
    },
  },
  navbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: '72px',
    width: '100%',
    padding: '0px 100px',
    borderTop: '1px solid #E3E3E3',
    borderBottom: '1px solid #E3E3E3',
  },
  grid: {
    width: '100%',
    maxWidth: '100%',
  },
  error: {
    color: palette.custom.red,
    fontSize: spacing(12),
  },
  select: {
    marginTop: '5px !important',
  },
  codeExternField: {
    marginTop: '25px',
  },
  required: {
    color: palette.custom.red,
    marginLeft: spacing(4),
  },
  errorMessage: {
    color: `${palette.error.main} !important`,
    margin: 0,
    fontSize: spacing(10.5),
    fontFamily: 'Roboto',
    height: spacing(10),
    display: 'flex !important',
  },
  checkbox: {
    marginRight: spacing(5),
  },

  tooltipIcon: {
    marginLeft: '8px',
    fontSize: '2.4rem',
    fontWeight: '500',
    lineHeight: '2.4rem',
    fill: palette.gray[64],
  },

  tooltipText: {
    fontSize: '1.4rem',
    color: 'white',
    textAlign: 'right',
  },

  subcontainer: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '38px 22px 12px',
    marginBottom: '30px',
    flexDirection: 'column',
    border: '1px solid #E3E3E3',
    borderRadius: '8px',
    gap: '24px',
  },
  wrapper: {
    display: 'grid',
    gridTemplateColumns: '320px 320px 320px',
    alignItems: 'start',
    marginRight: 'auto',
    width: '100%',
    gap: '44px',
    position: 'relative',
  },
  wrapperFull: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    alignItems: 'start',
    marginRight: 'auto',
    width: '100%',
    gap: '44px',
    position: 'relative',
  },
  input: {
    maxWidth: '400px',
  },
  label: {
    top: '-8px',
    left: '14px',
    padding: '0px 6px',
    position: 'absolute',
    backgroundColor: 'white',
  },
  inputLabel: {
    color: 'black',
    fontSize: '12px',
    fontWeight: '500',
    display: 'flex',
    gap: '4px',
  },
  checkboxField: {
    marginTop: '-40px',
    marginLeft: '5px',
  },
  adminField: {
    marginTop: '-20px',
    marginLeft: '5px',
  },
}))
